import React, { useEffect, useState } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import AddServicoModal from "./ServicosModal";

const Servicos = (props) => {
  document.title = "Serviços | Dashboard Olis";

  const [servicos, setServicos] = useState([]);
  const [data, setData] = useState({
    columns: [
      { label: "Área", field: "area", sort: "asc", width: 150 },
      { label: "Descrição", field: "descricao", sort: "asc", width: 150 },
      { label: "Valor", field: "valor", sort: "asc", width: 150 },
      {
        label: "Valor Parcelado",
        field: "valor_parcelado",
        sort: "asc",
        width: 150,
      },
      { label: "Status", field: "status", sort: "asc", width: 100 },
      { label: "Ações", field: "acoes", sort: "asc", width: 100 },
    ],
    rows: [],
  });

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [servicoEditavel, setServicoEditavel] = useState(null);

  useEffect(() => {
    getServicos(page, search);
  }, [page, search]);

  const getServicos = (page, search) => {
    fetch(
      `${process.env.REACT_APP_API}/subservicosPainel?page=${page}&limit=50&area=${search}`
    )
      .then((response) => response.json())
      .then((response) => {
        setServicos(response.data);
        setTotalPages(response.pagination.totalPages); // Atualiza o total de páginas dinamicamente

        setData((prevState) => ({
          ...prevState,
          rows: response.data.map((servico) => ({
            area: servico.areaNome,
            descricao: servico.Nome,
            valor: servico.Preco,
            valor_parcelado: servico.Preco_parcelado,
            status: servico.status === 1 ? "Ativo" : "Inativo",
            acoes: (
              <div>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => {
                    setServicoEditavel(servico);
                    setModalOpen(true);
                  }}
                >
                  Editar
                </Button>
              </div>
            ),
          })),
        }));
      })
      .catch((error) => console.error("Erro ao buscar serviços:", error));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage); // Atualiza a página atual
    }
  };

  return (
    <React.Fragment>
      <AddServicoModal
        isOpen={modalOpen}
        toggle={() => {
          setModalOpen(!modalOpen);
          setServicoEditavel(null);
        }}
        onServicoAdicionado={(message, type) => {
          toast(message, { type });
          getServicos(page, search); // Atualiza a lista após adicionar/editar serviço
        }}
        servicoEditavel={servicoEditavel}
      />

      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md={6}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por área"
                    value={search}
                    onChange={handleSearchChange}
                  />
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <Button
                    color="primary"
                    onClick={() => setModalOpen(true)}
                    className="mr-2"
                  >
                    Adicionar Serviço
                  </Button>
                </Col>
              </Row>

              {servicos.length > 0 ? (
                <MDBDataTable striped responsive bordered data={data} />
              ) : (
                <p>Nenhum serviço encontrado.</p>
              )}

              <div className="d-flex justify-content-between mt-3">
                <Button
                  color="primary"
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page <= 1}
                >
                  Anterior
                </Button>
                <span>
                  Página {page} de {totalPages}
                </span>
                <Button
                  color="primary"
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= totalPages}
                >
                  Próxima
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, {})(Servicos);
